import { CombinedGraphicalMetricData } from 'modules/Telematics/components/TelematicsRightPanel/LiveSummary/types';
import { ALERT_ICONS } from 'modules/Telematics/constants';

export const INIT_COMBINED_GRAPHICAL_METRICS_DATA: CombinedGraphicalMetricData =
	{
		ACCIDENT_STATUS: {
			staticData: {
				icon: { ...ALERT_ICONS['TRIANGLE-RED'] },
				backgroundColor: 'red',
			},
			graphData: [],
		},
		EXTERNAL_POWER_DISCONNECTED: {
			staticData: {
				icon: { ...ALERT_ICONS['CIRCLE-RED'] },
				backgroundColor: 'red',
			},
			graphData: [],
		},
		EXTERNAL_POWER_DISCONNECTED_AND_MOVING: {
			staticData: {
				icon: { ...ALERT_ICONS['ARROW-RED'] },
				backgroundColor: 'red',
			},
			graphData: [],
		},
		INTERNAL_BATTERY_LOW: {
			staticData: {
				icon: { ...ALERT_ICONS['CIRCLE-YELLOW'] },
				backgroundColor: 'yellow',
			},
			graphData: [],
		},
		INTERNAL_BATTERY_LOW_AND_MOVING: {
			staticData: {
				icon: { ...ALERT_ICONS['ARROW-YELLOW'] },
				backgroundColor: 'yellow',
			},
			graphData: [],
		},
		ENGINE_OFF: {
			staticData: {
				icon: { ...ALERT_ICONS['CIRCLE-PINK'] },
				backgroundColor: 'pink',
			},
			graphData: [],
		},
		SPRAYER_ON: {
			staticData: {
				icon: { ...ALERT_ICONS['SQUARE-BLUE'] },
				backgroundColor: 'blue',
			},
			graphData: [],
		},
		SPRAYER_ON_AND_MOVING: {
			staticData: {
				icon: { ...ALERT_ICONS['ARROW-BLUE'] },
				backgroundColor: 'blue',
			},
			graphData: [],
		},
		MACHINE_MOVING: {
			staticData: {
				icon: { ...ALERT_ICONS['ARROW-GREEN'] },
				backgroundColor: '#1cac1c',
			},
			graphData: [],
		},
		ENGINE_ON: {
			staticData: {
				icon: { ...ALERT_ICONS['SQUARE-GREEN'] },
				backgroundColor: '#1cac1c',
			},
			graphData: [],
		},
	};

export const ORDERED_METRIC_GRAPH_KEYS = [
	'ACCIDENT_STATUS',
	'EXTERNAL_POWER_DISCONNECTED',
	'EXTERNAL_POWER_DISCONNECTED_AND_MOVING',
	'INTERNAL_BATTERY_LOW',
	'INTERNAL_BATTERY_LOW_AND_MOVING',
	'ENGINE_OFF',
	'SPRAYER_ON',
	'SPRAYER_ON_AND_MOVING',
	'MACHINE_MOVING',
	'ENGINE_ON',
];
